<template>
  <b-row>
    <b-col sm="12">
      <b-card :title = "metadata.label">
        <template v-for="(item, index) in metadata.children">
          <FormComponent :metadata='item' :dbfield='index' :key='"comp_"+index' v-model="groupvalue[index]"
              v-on:input="$emit('input', groupvalue)" :isEdit="isEdit" :isSearch="isSearch"
              v-on:updatex="updatex"/>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import FormComponentBase from './FormComponentBase'

export default {
  name: 'FormComponentGroup',
  extends: FormComponentBase,
  components: {
    FormComponent: () => import('./FormComponent')
  },
  data () {
    return {
      groupvalue: {}
    }
  },
  mounted () {
    if (this.value) {
      this.groupvalue = this.value
    }
  },
  watch: {
    value: function (val) {
      /* for (var i in val) {
        this.$set(this.groupvalue, i, val[i])
      } */
      for (var item in this.metadata.children) {
        if (!(item in val)) {
          val.item = null
        }
      }
      this.$set(this, 'groupvalue', val)
      this.$emit('valuechange', val)
    }
  }
}
</script>
